// extracted by mini-css-extract-plugin
export default {"line":"Divider_line__zarML"};